import { useState } from "react";
import { Spinner } from "@/components/ui/spinner";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { Card, CardContent } from "@/components/ui/card";
import { Pagination } from "@/components/ui/pagination";
import { usePortalConsultations } from "@/hooks/api/useConsultations";

const PAGE_SIZE = 10;

export default function PatientPortal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const { data: response, isLoading } = usePortalConsultations({ page });

  const items = response?.data ?? [];
  const totalPages = Math.ceil((response?.total ?? 0) / PAGE_SIZE);

  return (
    <Layout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{t("portal.title")}</h1>
      </div>

      {isLoading ? (
        <Spinner />
      ) : !response?.total ? (
        <p className="text-muted-foreground">{t("portal.noConsultations")}</p>
      ) : (
        <>
          <div className="space-y-2">
            {items.map((c) => (
              <Card
                key={c.id}
                className="cursor-pointer hover:shadow-md transition-shadow"
                onClick={() => navigate(`/portal/consultation/${c.id}`)}
              >
                <CardContent className="p-4 flex items-center justify-between">
                  <div>
                    <p className="font-medium">{c.patientName}</p>
                    <p className="text-sm text-muted-foreground">
                      {new Date(c.startedAt).toLocaleDateString()}
                    </p>
                  </div>
                  <span
                    className={`text-xs px-2 py-1 rounded-full ${
                      c.status === "completed"
                        ? "bg-green-100 text-green-800"
                        : "bg-blue-100 text-blue-800"
                    }`}
                  >
                    {t(`dashboard.status.${c.status}`)}
                  </span>
                </CardContent>
              </Card>
            ))}
          </div>
          <Pagination
            page={page}
            totalPages={totalPages}
            totalItems={response!.total}
            pageSize={PAGE_SIZE}
            onPageChange={setPage}
          />
        </>
      )}
    </Layout>
  );
}
